import { version } from 'react';

const inertBooleanSupported = Number(version.split('.')[0]) >= 19;

/**
 * Allows proper value usage for react 18 / 19 inert property. `inert` is not in the
 * react 18 types for the HTMLAttributes and is treated differently.
 * @see https://stackoverflow.com/a/78606437/2143311
 * @see https://github.com/facebook/react/issues/17157
 * @internal
 */
// Need to use any here in order to create the proper overlap for react 18 and 19
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getProperInertValue(inert: boolean): any {
  if (inertBooleanSupported) {
    // Disable the ts rules, since they would error either in a react 18 or react 19 scenario in opposite ways
    // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/ban-ts-comment
    // @ts-ignore There is no overlap between react 18 inert types and react 19 inert types.
    return inert;
  }
  // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/ban-ts-comment
  // @ts-ignore There is no overlap between react 18 inert types and react 19 inert types.
  return inert ? '' : undefined;
}
